import { Cookies } from "webextension-polyfill";

export const MAX_COOKIE_JSON_STRING_LENGTH = 100000; // 100KB

export type CookieList = Cookies.Cookie[];

export type CookieResult = {
    cookies: CookieList;
    error:
        | "EXTENSION_NOT_INSTALLED"
        | "CONFIG_FETCH_ERROR"
        | "EXTENSION_REQUEST_ERROR"
        | "TOO_MANY_COOKIES"
        | null;
};

export const CookieSyncSupportedBrowsers = [
    "Chrome",
    "Firefox",
    "Edge",
] as const;
export type CookieSyncSupportedBrowserType = typeof CookieSyncSupportedBrowsers[number];

// TODO [LOWA-30534] from: https://tiny.amazon.com/i98fyhdr
export type CookieSynchronizationError =
    | "Timeout"
    | "AuthenticationError"
    | "ErrorResponse"
    | "InvalidResponse";
